export class ParametrosCBM {
  conciBancaParam: {
    idBanco: string;
    idEmpresa: string;
    refBanco?: string;
    claveBanco: string;
    formatoDucumento: string;
    saldoDisponibleInDetalle: boolean;
    columnaSaldoDispoible: number;
    filaSaldoDisponible: number;
    lineaInicialDatosCabecera: number;
    lineaInicialDatosDetalle: number;
    separador: string;
    //otroDelimitador: string;
  }
  listConciBancaParamCampo: [{
    idBanco: string;
    idEmpresa: string;
    refBanco?: string;
    pisicionColumna: number;
    nombreCampo: string;
  }];

  constructor(innParametrosCB: ParametrosCBM) {
    this.conciBancaParam = innParametrosCB.conciBancaParam;
    this.listConciBancaParamCampo = innParametrosCB.listConciBancaParamCampo;
  }
}
